module.exports = __webpack_public_path__ + "img/5.8377a175.jpg";